import { render, staticRenderFns } from "./SimpleLoadingChartContainer.vue?vue&type=template&id=2cfd0402&scoped=true&"
import script from "./SimpleLoadingChartContainer.vue?vue&type=script&lang=js&"
export * from "./SimpleLoadingChartContainer.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLoadingChartContainer.vue?vue&type=style&index=0&id=2cfd0402&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd0402",
  null
  
)

export default component.exports